import type { SocialSalesSourceDTO } from "@/modules/social-sales-sources/presentation/api/client";
import { RowActions } from "@/shared/ui/RowActions";
import { Badge, DataTable, type TanstackReactTable } from "@devhop/ui";
import { EditIcon } from "lucide-react";

type SocialSalesSourcesTableProps = {
  canEditRows: boolean;
  isLoading: boolean;
  data: SocialSalesSourceDTO[];
  onEdit: (row: SocialSalesSourceDTO) => void;
};

export function SocialSalesSourcesTable({
  canEditRows,
  isLoading,
  data,
  onEdit,
}: SocialSalesSourcesTableProps) {
  const columns: TanstackReactTable.ColumnDef<SocialSalesSourceDTO>[] = [
    {
      id: "code",
      header: "ລະຫັດ",
      cell: ({ row }) => (
        <span className="font-mono text-sm">{row.original.code}</span>
      ),
      size: 120,
    },
    {
      id: "name",
      header: "ຊື່",
      cell: ({ row }) => row.original.name,
      size: 160,
    },
    {
      id: "sortOrder",
      header: "ລຳດັບ",
      cell: ({ row }) => row.original.sortOrder,
      size: 72,
    },
    {
      id: "isActive",
      header: "ສະຖານະ",
      cell: ({ row }) =>
        row.original.isActive ? (
          <Badge variant="success">ເປີດ</Badge>
        ) : (
          <Badge variant="secondary">ປິດ</Badge>
        ),
      size: 88,
    },
    {
      id: "actions",
      cell: ({ row }) => {
        if (!canEditRows) return null;
        const actions = [
          {
            label: "ແກ້ໄຂ",
            icon: <EditIcon className="h-4 w-4" />,
            onClick: () => onEdit(row.original),
          },
        ];
        return <RowActions actions={actions} maxInline={2} />;
      },
      size: 100,
    },
  ];

  const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

  return (
    <DataTable<SocialSalesSourceDTO>
      columns={columns}
      data={data}
      isLoading={isLoading}
      totalCount={data.length}
      initialPageSize={PAGE_SIZE_OPTIONS[1]}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      hidePagination={data.length <= PAGE_SIZE_OPTIONS[1]}
    />
  );
}
